import React from "react";

const CustomersContext = React.createContext();

export const CustomersProvider = CustomersContext.Provider;
export const CustomersConsumer = CustomersContext.Consumer;

export default CustomersContext;